import { render } from "./agentlistkanban.vue?vue&type=template&id=89f094d0"
import script from "./agentlistkanban.vue?vue&type=script&lang=js"
export * from "./agentlistkanban.vue?vue&type=script&lang=js"

import "./agentlistkanban.vue?vue&type=style&index=0&id=89f094d0&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__